export enum FeatureName {
  JmccTransactionsReporting = 'Zing.PointOfSaleIntegration.JmccTransactionsReporting',
  ZingReportGenerationEnabled = 'Zing.Reporting.Enabled',
  ZingMarketplaceReturnDiamondsEnabled = 'Zing.Marketplace.ReturnDiamondsEnabled',
  ZingShippingBraintreeActive = 'Zing.Shipping.BraintreeActive',
  ZingMarketplaceAutomatedPayoutAndRefund = 'Zing.Marketplace.AutomatedPayoutAndRefund',
  BetaExperienceEnabled = 'Zing.Beta.ExperienceEnabled',
  MarketplaceExperienceEnabled = 'MarketplaceExperienceEnabled',
  IdentityAuth0AdminTooling = 'Zing.Identity.Auth0AdminTooling'
}
